import React from 'react';
import {useTranslation} from 'react-i18next';
import {AlertTriangle, Ban, CircleDollarSign, RotateCcw, ShieldAlert} from 'lucide-react';

interface PunishmentRow {
    key: string;
    icon: React.ReactNode;
    points: string;
}

const PunishmentTable = () => {
    const {t} = useTranslation();

    const punishments: PunishmentRow[] = [
        {
            key: 'cancel',
            icon: <RotateCcw size={15}/>,
            points: '< $10 → 33'
        },
        {
            key: 'cancel_100',
            icon: <RotateCcw size={15}/>,
            points: '$10 – < $100 → 33'
        },
        {
            key: 'cancel_100_plus',
            icon: <RotateCcw size={15}/>,
            points: '$100 → 66'
        },
        {
            key: 'not_accept',
            icon: <AlertTriangle size={15}/>,
            points: '< $10 → 33'
        },
        {
            key: 'not_accept_100',
            icon: <AlertTriangle size={15}/>,
            points: '$10 – < $100 → 33'
        },
        {
            key: 'not_accept_100_plus',
            icon: <AlertTriangle size={15}/>,
            points: '$100 → 66'
        },
        {
            key: 'not_deliver',
            icon: <ShieldAlert size={15}/>,
            points: '< $10 → 33'
        },
        {
            key: 'not_deliver_100',
            icon: <ShieldAlert size={15}/>,
            points: '$10 – < $100 → 33'
        },
        {
            key: 'not_deliver_100_plus',
            icon: <ShieldAlert size={15}/>,
            points: '$100 → 66'
        },
        {
            key: 'scam_attempt',
            icon: <Ban size={15}/>,
            points: '300'
        },
        {
            key: 'trade_revert',
            icon: <CircleDollarSign size={15}/>,
            points: '300'
        }
    ];

    return (
        <div className="mt-4 rounded-xl border border-white/5 bg-white/5 overflow-hidden">
            <div className="px-4 py-3 border-b border-white/5 flex items-center gap-2">
                <ShieldAlert size={15} className="text-red-500"/>

                <div>
                    <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
                        {t('dashboard.profile.standing.punishment_title')}
                    </span>

                    <p className="text-[10px] text-gray-500 mt-0.5">
                        {t('dashboard.profile.standing.punishment_description')}
                    </p>
                </div>
            </div>

            <div className="hidden md:grid grid-cols-[1.5fr_2fr_1fr] gap-4 px-4 py-2 border-b border-white/5">
                <span className="text-[9px] font-black uppercase tracking-widest text-gray-500">
                    {t('dashboard.profile.standing.punishment_action')}
                </span>

                <span className="text-[9px] font-black uppercase tracking-widest text-gray-500">
                    {t('dashboard.profile.standing.punishment_desc')}
                </span>

                <span className="text-[9px] font-black uppercase tracking-widest text-gray-500">
                    {t('dashboard.profile.standing.punishment_points')}
                </span>
            </div>

            <div className="divide-y divide-white/5">
                {punishments.map(punishment => (
                    <div
                        key={punishment.key}
                        className="grid grid-cols-1 md:grid-cols-[1.5fr_2fr_1fr] gap-2 md:gap-4 px-4 py-3 hover:bg-white/[0.02] transition-colors"
                    >
                        <div className="flex items-center gap-2">
                            <span className="text-gray-400">
                                {punishment.icon}
                            </span>

                            <span className="text-[10px] font-black uppercase tracking-wider">
                                {t(`dashboard.profile.standing.punishment_${punishment.key}`)}
                            </span>
                        </div>

                        <div className="flex items-center">
                            <span className="text-[10px] text-gray-500 dark:text-slate-400">
                                {t(`dashboard.profile.standing.punishment_${punishment.key}_desc`)}
                            </span>
                        </div>

                        <div className="flex items-center md:justify-end">
                            <span className="text-xs font-black font-mono text-red-400">
                                {punishment.points}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PunishmentTable;